import React, { useContext, useEffect, useState } from "react";
import { HotelOwnerContext } from "../HotelOwnerContext";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser} from '@fortawesome/free-solid-svg-icons';

export default function HotelOwnerCommunFarmer() {
  const { handleSendMessage,hotelFarmers,hotelOnwerData} = useContext(HotelOwnerContext);  
  const [chatMessages, setChatMessages] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const baseUrl = process.env.REACT_APP_SECOND_BACKEND_URL

  useEffect(() => {
    if (hotelOnwerData?.username && selectedUser) {
      axios.get(`${baseUrl}/messages/${hotelOnwerData?.username}/${selectedUser}`)
        .then(res => {
          let newMessages=res.data.Response
          setChatMessages(newMessages)
          
        })
        .catch(error => {
          console.error("An error occurred", error);
        });
    }
  }, [hotelOnwerData?.username, selectedUser]);

  useEffect(() => {
    if (selectedUser.length > 0) {
      formik.setFieldValue("recipient", selectedUser);
    }
  }, [selectedUser]);

  const formik = useFormik({
    initialValues: {
      sender: hotelOnwerData?.username,
      recipient: selectedUser,
      text: ""
    },
    validationSchema: yup.object().shape({
      text: yup.string("Text should be a string").required("Text is required").typeError("Text should be a string")
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const newMessage = { ...values, timestamp: new Date().toISOString() };
        await handleSendMessage(newMessage);
        setChatMessages(prevMessages => [...prevMessages, newMessage]);
        formik.resetForm();
      } catch (error) {
        console.error("An error occurred sending messages", error);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const handleSelectUser = (e) => {
    setSelectedUser(e.target.value);
  };

  const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, msg) => {
      // Convert UTC to local time for grouping
      const localDate = moment.utc(msg.timestamp).local().format("YYYY-MM-DD");
      if (!acc[localDate]) {
        acc[localDate] = [];
      }
      acc[localDate].push(msg);
      return acc;
    }, {});
  };
  

  

  const groupedMessages = groupMessagesByDate(chatMessages);

  return (
    <div className="mt-2  mb-16">
      {hotelFarmers ? (
        <div>
          <form>
            <select onChange={handleSelectUser} className="block w-full p-2 border border-gray-300 rounded">
              <option>Select a farmer</option>
              {hotelFarmers.map((farmer, index) => (
                <option value={farmer.username} key={index}>{farmer.username}</option>
              ))}
            </select>
          </form>
        </div>
      ) : (
        <p>Sorry, no farmer to communicate with</p>
      )}
      {selectedUser.length > 0 && (
        <div className="flex flex-col flex-grow border rounded shadow-lg bg-white mt-4 mb-10">
          <div className="flex-grow overflow-y-auto p-4">
            {Object.keys(groupedMessages).length > 0 ? (
              Object.entries(groupedMessages).map(([date, messages], dateIndex) => (
                <div key={dateIndex}>
                  <div className="text-center text-gray-500 mb-2">
                    {moment(date).format("MMMM DD YYYY")}
                  </div>
                  {messages.map((msg, index) => (
                    <div
                      key={index}
                      className={`mb-2 p-2 rounded max-w-fit min-w-fit ${
                        msg.sender === hotelOnwerData?.username
                          ? "ml-auto bg-green-100"
                          : "mr-auto bg-gray-200"
                      }`}
                      style={{
                        alignSelf: msg.sender === hotelOnwerData?.username ? 'flex-end' : 'flex-start',
                      }}
                    >
                     <div className=" flex flex-row justify-between">
                      <p className=" mr-10">{msg.text}</p>
                      <FontAwesomeIcon icon={faUser}/>
                     </div>
                      <div className="text-sm text-gray-600 flex justify-between">
                        <span className=" mr-10">{msg.sender === hotelOnwerData?.username ? "You" : msg.sender}</span>
                        <span>{moment.utc(msg.timestamp).local().format("LT")}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500">
                No messages yet. Start the conversation!
              </p>
            )}
          </div>
          <form className="p-4 border-t flex items-center max-w-full min-w-fit" onSubmit={formik.handleSubmit}>
            <input
              name="text"
              value={formik.values.text}
              onChange={formik.handleChange}
              className="flex-grow p-2 border rounded mr-2"
              placeholder="Type a message..."
            />
            <button
              type="submit"
              className="p-2 bg-blue-500 text-white rounded disabled:opacity-50"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Send
            </button>
          </form>
        </div>
      )}
    </div>
  );
}